import { Chip, Skeleton } from '@billda/design-system';

interface PeriodBadgeProps {
  weekLabel: string | null;
  dateRange: string | null;
  isLoading: boolean;
}

export function PeriodBadge({
  weekLabel,
  dateRange,
  isLoading,
}: PeriodBadgeProps) {
  if (isLoading) {
    return (
      <div className="flex flex-col items-end gap-0.5">
        <Skeleton width={120} height={32} />
        <Skeleton width={100} height={20} />
      </div>
    );
  }

  if (!weekLabel) {
    return null;
  }

  return (
    <div className="flex flex-col items-end gap-0.5">
      <Chip
        label={weekLabel}
        color="success"
        variant="outlined"
        size="sm"
        className="font-semibold"
      />
      {dateRange ? (
        <span className="type-caption text-content-secondary">{dateRange}</span>
      ) : null}
    </div>
  );
}
